import { lazy } from 'react';
import AoReports from './ao-analysis/AoReports';
import ReportDashboard from './reportDashboard/ReportDashboard';
import FactoryIssueNkReport from './factory-issues/FactoryIssueNKReport';


const ReportsConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/reports/ao-analysis',
            element: <AoReports />,
        },
        {
            path: '/reports/reportDashboard',
            element: <ReportDashboard />,
        },
        {
            path: '/reports/:category/:type',
            element: <ReportDashboard />,
        },
         {
            path: '/reports/factory-issues',
            element: <FactoryIssueNkReport/>
        },
       
    ],
};

export default ReportsConfig;
